import { Controller } from '@hotwired/stimulus';

// Shows only the fields that the trigger's current value applies to - the band terms form
// asks for an amount OR a percentage, never both.
//
// Progressive enhancement: the server renders every dependent field visible and every one
// of them submits, so with no JS the form is merely busier, not broken. `hidden` is toggled
// as a literal class here rather than baked into a component class (frontend.md).
//
//   <div data-controller="conditional-field" data-action="change->conditional-field#update">
//     <div data-conditional-field-target="trigger"><%= render SelectComponent.new(...) %></div>
//     <div data-conditional-field-target="dependent" data-shown-for="amount">
//
// The dependent target must wrap the WHOLE field, label included - putting it on the input
// alone leaves a label hanging over nothing.
export default class extends Controller {
  static targets = ['trigger', 'dependent'];

  connect() {
    this.update();
  }

  update() {
    const value = this.triggerValue;

    this.dependentTargets.forEach((field) => {
      const shownFor = (field.dataset.shownFor || '').split(' ');
      field.classList.toggle('hidden', !shownFor.includes(value));
    });
  }

  // Either a control marked directly (a native select) or a wrapper around SelectComponent's
  // radio grid, which is where "what's picked" actually lives.
  get triggerValue() {
    const trigger = this.triggerTarget;
    if (trigger.matches('select, input')) return trigger.value;

    return trigger.querySelector('input:checked')?.value || '';
  }
}
